import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FotaRoutingModule } from './fota-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { FotaManagementComponent } from './fota-management/fota-management.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateFotaComponent } from './create-fota/create-fota.component';
import { FotaJobDetailsComponent } from './fota-job-details/fota-job-details.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { AgmCoreModule } from '@agm/core';
import { MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
  declarations: [ CreateFotaComponent, FotaManagementComponent, FotaJobDetailsComponent ],
  imports: [
    CommonModule,
    FotaRoutingModule,
    MatTabsModule,
    TranslateModule,
    MatTableModule,
    SharedModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatDatepickerModule,
    MatCardModule,
    SharedModule,
    MatExpansionModule,
    MatMenuModule,
    MatRadioModule,
    FormsModule,
    AgmCoreModule,
    MatTooltipModule
  ]
})
export class FotaModule { }
